export const generateOtpComponentRef = 'otp-generation-form';
